module.exports = __webpack_public_path__ + "static/media/26-2.c4925004.mp3";